export type PortalPermissions = {
  isAdmin: boolean;
  isDataOwnerReviewer: boolean;
  isPrivacyReviewer: boolean;
  isAuditor: boolean;
};

export const defaultPerms: PortalPermissions = { isAdmin: false, isDataOwnerReviewer: false, isPrivacyReviewer: false, isAuditor: false };
